import React from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles(() =>
    createStyles({
        textField: {
            width: "100%"
        }
    })
);

interface ISearchBox {
    onSearchChange(newValue: string): void;
    placeholder: string;
    label: string;
    [x: string]: any;
    onKeyPress?(event: React.KeyboardEvent<HTMLDivElement>): void;
}

const SearchBox: React.FC<ISearchBox> = ({
    onSearchChange,
    placeholder,
    label,
    value,
    onKeyPress
}) => {
    const classes = useStyles();

    return (
        <form onSubmit={event => event.preventDefault()}>
            <TextField
                label={label}
                placeholder={placeholder}
                type="search"
                className={classes.textField}
                margin="none"
                variant="outlined"
                autoFocus
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                    onSearchChange(event.currentTarget.value)
                }
                value={value}
                onKeyPress={onKeyPress}
            />
        </form>
    );
};

export { SearchBox };
